import { NullableText, Text } from 'lib/graphql/graphql';
import { Languages } from 'lib/providers/Language/LanguageContext';
import { EventContext } from 'providers/EventProvider/EventContext';
import { useContext } from 'react';

import LocalizedText from './LocalizedText';

interface LocalizedTextProps {
  text: NullableText | Text
  fallback?: string
}

function EventLocalizedText(props: LocalizedTextProps) {
  const event = useContext(EventContext);

  const eventLanguage = event.languages[0] as Languages;

  return <LocalizedText {...props} fallbackLanguage={eventLanguage} />;
}

export default EventLocalizedText;
